import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import { MdOutlineAccessTimeFilled } from "react-icons/md";
import "../styles/MagneticGrillCleaningModal.css";

// const RecentUnsafeEventsModal = ({ recentUnsafeEventData, showModal, onHide }) => {
//     // Dummy Data (static for demo)
//     const dummyData = {
//         shift: "I",
//         file_name: "https://suhana-yawat-turmeric-unsafe-events.s3.ap-south-1.amazonaws.com/spk_printing/20250617_082437.jpg",
//         partition_key: "packaging#stick_metal_detector#calibration",
//         timestamp: "2025-06-17T08:24:39.083076+05:30"
//     };

//     const getShiftBadgeColor = (shift) => {
//         switch (shift) {
//             case "I": return "bg-primary";
//             case "II": return "bg-success";
//             case "III": return "bg-warning";
//             default: return "bg-secondary";
//         }
//     };

//     console.log("recent unsafe events --->>>", recentUnsafeEventData)

//     return (
//         <Modal show={showModal} onHide={onHide} centered size="lg" backdrop="static">
//             <Modal.Header closeButton>
//                 <Modal.Title className="fs-5">Metal Detector Calibration History</Modal.Title>
//             </Modal.Header>

//             <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
//                 <div className="text-center mb-3">
//                     {dummyData.shift && (
//                         <span className={`badge ${getShiftBadgeColor(dummyData.shift)}`}>
//                             Shift {dummyData.shift}
//                         </span>
//                     )}
//                 </div>

//                 <div className="d-flex justify-content-center mb-4">
//                     <div className="status-card p-3 border rounded shadow-sm" style={{ width: "60%" }}>
//                         <div className="d-flex align-items-center justify-content-center">
//                             <MdOutlineAccessTimeFilled className="me-2" style={{ width: "25px", height: "25px", color: "#0d6efd" }} />
//                             <div className="text-center">
//                                 <div className="status-title mb-1"><strong>Calibration Date & Time</strong></div>
//                                 <div className="text-primary fw-bold">
//                                     {new Date(dummyData.timestamp).toLocaleString()}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="d-flex justify-content-center">
//                     <div
//                         style={{
//                             width: "80%",
//                             display: "flex",
//                             flexDirection: "column",
//                             justifyContent: "center",
//                             alignItems: "center",
//                         }}
//                     >
//                         <img
//                             src={dummyData.file_name}
//                             alt="Calibration"
//                             className="img-fluid rounded shadow"
//                             style={{
//                                 maxHeight: "300px",
//                                 maxWidth: "100%",
//                                 cursor: "pointer",
//                                 border: "2px solid #dee2e6"
//                             }}
//                             onClick={() => window.open(dummyData.file_name, "_blank")}
//                         />
//                         <div className="mt-2 text-muted">
//                             <FiCalendar className="me-1" />
//                             <small>Click to view full image</small>
//                         </div>
//                     </div>
//                 </div>
//             </Modal.Body>

//             <Modal.Footer>
//                 <Button variant="secondary" onClick={onHide}>Close</Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };

// export default RecentUnsafeEventsModal;

const RecentUnsafeEventsModal = ({
    showModal,
    onHide,
    currentHopper,
    currentRtcComponent,
    currentCardType,
    recentUnsafeEventData,
    rtcRecentUnsafeEventData,
}) => {
    const getShiftBadgeColor = (shift) => {
        switch (shift) {
            case "I": return "bg-primary";
            case "II": return "bg-success";
            case "III": return "bg-warning";
            default: return "bg-secondary";
        }
    };

    // Determine which data source to use: RTC or Packaging
    const isRtcSource = !!currentRtcComponent;
    const dataSource = isRtcSource
        ? rtcRecentUnsafeEventData?.[currentRtcComponent]
        : recentUnsafeEventData?.[currentHopper];

    // Keys based on card type: "magnetic_grill" or "safety_mesh"
    const imageKey = `last_${currentCardType}_presence_image`;
    const timestampKey = `last_${currentCardType}_presence_timestamp`;

    const imageUrl = dataSource?.[imageKey];
    const timestamp = dataSource?.[timestampKey];

    return (
        <Modal show={showModal} onHide={onHide} centered size="lg" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title className="fs-5">
                    {currentCardType === "magnetic_grill"
                        ? "Magnetic Grill Image"
                        : currentCardType === "safety_mesh"
                            ? "Safety Mesh Image"
                            : "Unsafe Event History"}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
                {timestamp && (
                    <div className="text-center mb-3">
                        <span className={`badge ${getShiftBadgeColor("I")}`}>Shift I</span>
                    </div>
                )}

                {timestamp && (
                    <div className="d-flex justify-content-center mb-4">
                        <div className="status-card p-3 border rounded shadow-sm" style={{ width: "60%" }}>
                            <div className="d-flex align-items-center justify-content-center">
                                <MdOutlineAccessTimeFilled className="me-2" style={{ width: "25px", height: "25px", color: "#0d6efd" }} />
                                <div className="text-center">
                                    <div className="status-title mb-1"><strong>Last Event Timestamp</strong></div>
                                    <div className="text-primary fw-bold">
                                        {new Date(timestamp).toLocaleString()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {imageUrl ? (
                    <div className="d-flex justify-content-center">
                        <div
                            style={{
                                width: "80%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <img
                                src={imageUrl}
                                alt="Unsafe Event"
                                className="img-fluid rounded shadow"
                                style={{
                                    maxHeight: "300px",
                                    maxWidth: "100%",
                                    cursor: "pointer",
                                    border: "2px solid #dee2e6"
                                }}
                                onClick={() => window.open(imageUrl, "_blank")}
                            />
                            <div className="mt-2 text-muted">
                                <FiCalendar className="me-1" />
                                <small>Click to view full image</small>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="text-center text-muted mt-3">
                        No image available for this event.
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RecentUnsafeEventsModal;

